import { Component, ElementRef, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { ToastrService } from "ngx-toastr";
import { UsersDataSource } from "../delete-user/deleted-users-list.datasource";
import { MatPaginator, MatTableDataSource, MatSort, Sort, MatDatepicker } from '@angular/material';
import { tap } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.css']
})
export class DeleteUserComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute) {
    DeleteUserComponent.app_id = this.activatedRoute.snapshot.params['id'];
    this.org_id = localStorage.getItem('org_id');
    // this.listallUsersWithinOrg();
  }
  dateError: boolean;
  static app_id: any;
  userList: any = [];
  org_id: any;
  displayedColumns: string[] = ['name', 'username', 'email_id', 'latestLoginDate', 'deleteOn'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('input') input: ElementRef;
  clientTimezone: string;
  isLoading: boolean;
  dataSource: any;
  defaultPageNumber = 1;
  defaultPageSize = 10;
  isLoadingStats = false;
  maxDate:Date=new Date();
  minDate:Date= new Date();
  today=new Date();
  startDate:Date = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7);
  endDate:Date =new Date();
  searchText:String=null;
  ngOnInit() {
    this.dataSource = new UsersDataSource(this.authService);
    this.dataSource.listallDeletedUsers_within_App(this.org_id, this.defaultPageNumber, this.defaultPageSize,null,null,null,null,this.startDate,this.endDate);
  }
  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.paginator.page
      .pipe(
        tap(() => {
          debugger
          this.isLoading=true;
          return this.dataSource.listallDeletedUsers_within_App(
            this.org_id, this.paginator.pageIndex + 1, this.paginator.pageSize, null,null,null,null,this.startDate,this.endDate
          )
        })
      )
      .subscribe();

    this.sort.sortChange
      .subscribe((sort: Sort) => {
        this.isLoading=true;
        const sortField = sort.active;
        const sortDirection = sort.direction
        return this.dataSource.listallDeletedUsers_within_App(
          this.org_id, this.defaultPageNumber, this.defaultPageSize, sortField, sortDirection,this.searchText,null,this.startDate,this.endDate
        )
      });

      fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        tap((value: any) => {
          if (value.code == 'Enter' || value.target.value == '') {
            this.isLoading=true;
            return this.dataSource.listallDeletedUsers_within_App(
              this.org_id, this.defaultPageNumber, this.defaultPageSize,null,null,value.target.value,null,this.startDate,this.endDate
            )
          }
        })
      )
      .subscribe();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  openDatePicker(datePicker: MatDatepicker<Date>): void {
    datePicker.open();
  }
  checkDateValidity() {
    // Check if the "To" date is less than the "From" date
    const startDate = this.startDate;
    const endDate = this.endDate;
    if (startDate && endDate && startDate > endDate) {
      this.dateError = true;
    } else {
      this.dateError = false;
    }
  }
  resetFilters() {
    this.input.nativeElement.value = '';
    this.searchText=null;
    this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7);;
    this.endDate =new Date();
    this.paginator.pageIndex=this.defaultPageNumber - 1;
    this.paginator.pageSize=this.defaultPageSize;
    this.dateError = false;
    this.dataSource.listallDeletedUsers_within_App(
      this.org_id,
      this.defaultPageNumber,
      this.defaultPageSize,
      null,
      null,
      this.searchText,
      null,
      this.startDate,
      this.endDate)
  }
  searchFilters(){
    this.endDate.setHours(23, 59, 59, 999); // Sets hours, minutes, seconds, and milliseconds
    this.dataSource.listallDeletedUsers_within_App(
      this.org_id,
      this.defaultPageNumber,
      this.defaultPageSize,
      null,
      null,
      this.searchText,
      null,
      this.startDate,
      this.endDate)
  }
  downloadReport(fileType:string){
      if ('Intl' in window) {
        const resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
        this.clientTimezone = resolvedOptions.timeZone;
        console.log('Client timezone:', this.clientTimezone);
      } else {
        console.log('Intl API not supported in this browser.');
        // You can implement a fallback logic if the Intl API is not supported in the browser.
        // For example, use the UTC offset from the server.
      }

    const fileUrl=`${environment.serverUrl}auth/listdeletedusers-within-org/${this.org_id}?pageNumber=1&pageSize=${Number.MAX_SAFE_INTEGER}&sortField=null&sortType=null&searchText=${this.searchText}&searchField=null&startDate=${this.startDate}&endDate=${this.endDate}&fileType=${fileType}&tz=${this.clientTimezone}`;
    fetch(fileUrl, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(response => response.blob())
      .then(blob => {
        // Create a temporary URL for the file blob
        const downloadUrl = URL.createObjectURL(blob);

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `user-report.${new Date}.${fileType}`;

        // Trigger the download
        link.click();
      })
      .catch(error => {
        console.error('Error downloading the file:', error);
      });
  }

  onPaste($event: ClipboardEvent) {
    $event.preventDefault();
    const clipboardData = $event.clipboardData || window['clipboardData'];
    const pastedText = clipboardData.getData('text/plain');
    this.searchText = pastedText.trim();
  }
}
